/* global Excel */

import { MacroId } from "@/types/lighthouse";
import { vlookup } from "./vlookup";
import { avgifsSingleCriteria } from "./avgifsSingleCriteria";
import { avgifsMultiCriteria } from "./avgifsMultiCriteria";
import { sumifsSingleCriteria } from "./sumifsSingleCriteria";
import { sumifsMultiCriteria } from "./sumifsMultiCriteria";
import { indexMatch } from "./indexMatch";

export const macroImplementations: Record<MacroId, (context: Excel.RequestContext) => Promise<void>> = {
  vlookup: vlookup,
  "avgifs-single-criteria": avgifsSingleCriteria,
  "avgifs-multi.-criteria": avgifsMultiCriteria,
  "sumifs-single-criteria": sumifsSingleCriteria,
  "sumifs-multi.-criteria": sumifsMultiCriteria,
  "index-match": indexMatch,
};
